import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Text from '@kurtosys/ksys-app-components/dist/components/base/Text/Text';

export default InjectedStyledComponent(Text, 'footnote', ['text']);